export default {
  path: "/SectionContent/CrashSpecificInformation",
  name: "Crash Specific Information",
  htmlContent: "crash_specific_information.html",
  headings: [
    { id: "n1AgencyCaseNumber", text: "1.   Agency Case Number ", type: "field" },
    {
      id: "n2AgencyNCICNumberRecordTheORIOriginatingAgencyIdentifier",
      text: "2.   Agency NCIC Number Record the ORI (Originating Agency Identifier)",
      type: "field",
    },
    { id: "CrashTimeline", text: "Crash Timeline", type: "heading" },
    { id: "n4EstimatedCrashDate", text: "4.   Estimated Crash Date ", type: "field" },
    { id: "n5EstimatedCrashTime", text: "5.   Estimated Crash Time ", type: "field" },
    { id: "n6DispatchDate", text: "6.   Dispatch Date ", type: "field" },
    { id: "n7DispatchTime", text: "7.   Dispatch Time ", type: "field" },
    { id: "n8ArrivalDate", text: "8.   Arrival Date ", type: "field" },
    { id: "n9ArrivalTime", text: "9.   Arrival Time ", type: "field" },
    { id: "UnitsAndCasualties", text: "Units and Casualties", type: "heading" },
    { id: "n10TotalNumberOfVehicles", text: "10. Total Number of Vehicles", type: "field" },
    { id: "n11TotalNumberOfInjuries", text: "11. Total Number of Injuries", type: "field" },
    { id: "n12TotalNumberOfFatalities", text: "12. Total Number of Fatalities", type: "field" },
    { id: "ReportType", text: "Report Type", type: "heading" },
    { id: "n20CorrectedReport", text: "20. Corrected Report ", type: "field" },
    { id: "n21SupToOriginal", text: "21. Sup to Original ", type: "field" },
    { id: "n22HitAndRun", text: "22. Hit and Run ", type: "field" },
    { id: "AdministrativeFields", text: "Administrative Fields", type: "heading" },
    { id: "Photos", text: "Photos", type: "heading" },
    { id: "n115PhotosTakenBy", text: "115. Photos Taken? / By ", type: "field" },
    { id: "InvestigatingOfficer", text: "Investigating Officer", type: "heading" },
    {
      id: "n116ReportedByAgencyReportDate",
      text: "116. Reported By/ Agency / Report Date ",
      type: "field",
    },
    { id: "ReviewingOfficer", text: "Reviewing Officer", type: "heading" },
    { id: "n117CheckedByDateChecked", text: "117. Checked By/ Date Checked ", type: "field" },
  ],
};
